import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { SpreadsheetContainerState } from './spreadsheet';
type SpreadsheetSheet = kendo.ui.SpreadsheetSheet;

const initialState: SpreadsheetContainerState = {
  sheets: [],
};

export const slice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setSheets: (state, action: PayloadAction<SpreadsheetSheet[]>) => {
      state.sheets = action.payload;
    },
    addSheets: (state, action: PayloadAction<SpreadsheetSheet[]>) => {
      const countSheets = state.sheets.length / 2;
      action.payload.forEach((sheet) => {
        if (sheet.name) {
          sheet.name = sheet.name + (countSheets ? countSheets : '');
        }
      });
      state.sheets = state.sheets.concat(action.payload);
    },
  },
});

export const { setSheets, addSheets } = slice.actions;

export default slice.reducer;
